import { gql } from 'graphql-tag'

export const getTeacherClasses = gql`
  query GetTeacherClasses {
    getTeacherClasses {
      id
      name
      degree
    }
  }
`
